import { z } from 'zod';

/**
 * Papéis atribuíveis a um Membro de um tenant (ADR 006/007).
 * `platform_admin` é cross-tenant e não é um Membro.
 */
export const MEMBRO_ROLES = ['owner', 'colaborador'] as const;
export type MembroRole = (typeof MEMBRO_ROLES)[number];

/** Convite de colaborador criado pela owner. */
export const conviteSchema = z.object({
  email: z
    .string()
    .email('Email inválido')
    .transform((e) => e.trim().toLowerCase()),
  role: z.literal('colaborador').default('colaborador'),
});

export type ConviteInput = z.infer<typeof conviteSchema>;

/** Alteração de papel de um membro existente. */
export const alterarPapelSchema = z.object({
  role: z.enum(MEMBRO_ROLES),
});

export type AlterarPapelInput = z.infer<typeof alterarPapelSchema>;

/**
 * Preferência de e-mails de relacionamento (régua de onboarding, dicas) — #363.
 * E-mails transacionais (convite, confirmação do Pro, Cognito) não dependem dela.
 */
export const preferenciasEmailSchema = z.object({
  emailsRelacionamento: z.boolean(),
});

export type PreferenciasEmail = z.infer<typeof preferenciasEmailSchema>;

/** De onde veio a última mudança da preferência (mesmo padrão de `consentimentoOrigem`). */
export const ORIGENS_PREFERENCIA_EMAIL = ['perfil', 'link', 'one-click', 'ses-complaint'] as const;
export type OrigemPreferenciaEmail = (typeof ORIGENS_PREFERENCIA_EMAIL)[number];

/**
 * O que o token de descadastro desliga: a régua de onboarding do usuário ou
 * os lembretes de cobrança que uma loja manda a um cliente.
 */
export const TIPOS_DESCADASTRO = ['onboarding', 'cobranca'] as const;
export type TipoDescadastro = (typeof TIPOS_DESCADASTRO)[number];

/** Resposta de `GET /api/public/descadastro/{token}` (sem PII). */
export interface DescadastroInfo {
  tipo: TipoDescadastro;
  /** `true` enquanto os e-mails ainda são enviados. */
  ativo: boolean;
  /** Só para `cobranca`: o descadastro vale para esta loja. */
  lojaNome?: string;
}
